/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import ExclamationIcon from '../../../assets/images/temp/ico-exclamation.png';
import FlexRootWrapper from '../../../components/general/flex-root';
import Button from '../../../components/general/button';
import Chevron from '../../../components/general/navigation-chevron';
import {tasksSelect, tasksUpdate} from '../../../store/tasks/actions';
import {getTasksCurrent} from '../../../store/tasks/selectors';
import {getTaskErrormessage} from "../../../store/tasks/selectors";
import {tasksAcceptErrormessage} from "../../../store/tasks/actions";

const ContentWrapper = styled(FlexRootWrapper)`
	background: #4a4a50;
	padding: 51px 72px 55px;
`;

const WarningBar = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	background: repeating-linear-gradient(-45deg, #f43d3d, #f43d3d 15px, #f76d6d 10px, #f76d6d 30px);
	padding: 8px 10px;
`;

const WarningIcon = styled.img`
	margin-right: 8px;
`;

const WarningTitle = styled.span`
	text-align: center;
	font-size: 30px;
	font-weight: 600;
	color: #fff;
`;

const WarningsList = styled.ul`
	list-style: none outside;
	font-size: 20px;
	color: #fff;
	padding-top: 35px;
	padding-left: 19px;
`;

const WarningListItem = styled.li`
	position: relative;
	padding-bottom: 30px;

	&:before {
		content: "";
		position: absolute;
		top: 5px;
		left: -19px;
		width: 11px;
		height: 11px;
		background: #fff;
		border-radius: 50%;
	}
`;

const ProceedButtton = styled(Button)`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 178px;
	font-size: 14px;
	border-width: 2px;
	background: fff;
	margin: 10px auto 10px auto;
	padding: 5px 10px 5px 10px;
`;

const Message = styled.p`
    color: #fff;
    text-align: center;
`;



class Warning extends React.Component {
    enableTask = () => {
        const {task, tasksUpdate, tasksAcceptErrormessage} = this.props;

        tasksAcceptErrormessage(task);
    };

    render() {
        const {task, errormessage} = this.props;

        return (
            <FlexRootWrapper>
                <WarningBar>
                    <WarningIcon src={ExclamationIcon}/>

                    <WarningTitle>ACHTUNG</WarningTitle>
                </WarningBar>

                <ContentWrapper>
                    <WarningTitle>
                        Bei diesem Arbeitsschritt
                        <br/>
                        können diese Fehler / Probleme auftreten:
                    </WarningTitle>

                    {errormessage && errormessage.length > 0 && (
                        <WarningsList>
                            {errormessage.map((warning, index) => (
                                <WarningListItem key={`task-warning-item-${index}`}>
                                    <div dangerouslySetInnerHTML={{__html: warning}}/>
                                </WarningListItem>
                            ))}
                        </WarningsList>
                    )}

                    <Message>Hiermit bestätige ich, dass ich die Fehler anerkenne und darauf achten werde.</Message>
                    <ProceedButtton onClick={this.enableTask}>
                        akzeptieren

                        <Chevron/>
                    </ProceedButtton>
                </ContentWrapper>
            </FlexRootWrapper>
        );
    }
}

export default connect(
    (state) => ({
        task: getTasksCurrent(state),
        errormessage: getTaskErrormessage(state),
    }), {
        tasksUpdate,
        tasksSelect,
        tasksAcceptErrormessage,
    }
)(Warning);



// WEBPACK FOOTER //
// ./src/containers/task/working/warning.js